export default __webpack_public_path__ + "static/media/import.f6ce5cd2.svg";